module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji@2x.aac65c76.jpg";